module.exports = __webpack_public_path__ + "img/custom.799aeb5b.svg";